
import { HttpClient } from "@angular/common/http";
import { computed, inject, Injectable, Signal, signal, WritableSignal } from "@angular/core";
import { SuggestionsConfigData, TraceSuggestionsComponent } from "@tt-lib/components/trace/trace-suggestions/trace-suggestions.component";
import { AppEnvironmentConfig } from "@tt-lib/interfaces/app-environment-config";
import { TT_LIB_ENV_CONFIG } from "@tt-lib/tt-lib-env.config.token";

//we keep the suggestions config in this service class so that we can include this small class in the map component instead of the much bigger trace service class
//many applications (uce, geobe) don't use the trace service, so we would unnecessarily reference the trace service class
@Injectable({
  providedIn: "root",
})
export class TraceSuggestionsConfigService {

  private _configDownloadStatus: WritableSignal<'init' | 'busy' | 'done' | 'linkerror'> = signal('init');
  public configDownloadStatus: Signal<'init' | 'busy' | 'done' | 'linkerror'> = computed(() => this._configDownloadStatus());

  private _configData: WritableSignal<SuggestionsConfigData> = signal(TraceSuggestionsComponent.checkConfigData({}));
  public configData: Signal<SuggestionsConfigData> = computed(() => this._configData());

  private _appEnvironmentConfig: AppEnvironmentConfig = inject(TT_LIB_ENV_CONFIG);

  constructor(
    private _httpService: HttpClient
  ) { }

  /**
   * 
   * @param checkedSuggestionsConfigData this object should already be checked for valid content (TraceSuggestionsComponent.checkConfigData)
   */
  /*
  public setDownloadedConfigData(checkedSuggestionsConfigData: SuggestionsConfigData) {
    this._configData.set(checkedSuggestionsConfigData ? checkedSuggestionsConfigData : TraceSuggestionsComponent.checkConfigData({}));
    this.setDownloadstatus('done');
  }

  public setDownloadstatus(status: 'init' | 'busy' | 'done') {
    this._configDownloadStatus.set(status);
  }
  */

  public downloadConfigData(showSuggestionsOnMapAfterDownload: boolean) {
    if (this._configDownloadStatus() === 'init') {
      this._configDownloadStatus.set('busy');

      if (typeof this._appEnvironmentConfig.TRACE_SUGGESTIONS_CONFIG === "string" && (/^http(s)?\/\//.test(this._appEnvironmentConfig.TRACE_SUGGESTIONS_CONFIG) || this._appEnvironmentConfig.TRACE_SUGGESTIONS_CONFIG.indexOf('assets/') > -1)) {
        this._httpService.get(this._appEnvironmentConfig.TRACE_SUGGESTIONS_CONFIG).subscribe({
          next: (data) => {
            const checkConfigData = TraceSuggestionsComponent.checkConfigData(data);

            //override default value for 'route_centroids_on_map' if necessary
            if (showSuggestionsOnMapAfterDownload && checkConfigData.form_options.route_centroids_on_map.form_checked !== showSuggestionsOnMapAfterDownload) {
              checkConfigData.form_options.route_centroids_on_map.form_checked = showSuggestionsOnMapAfterDownload;
            }

            this._configData.set(checkConfigData);
            this._configDownloadStatus.set('done');
          },
          error: (error) => {
            this._configDownloadStatus.set('init');
            console.error("error downloading suggestions config", error);
          }
        });
      } else {
        this._configDownloadStatus.set('linkerror');
        console.log("the suggestions configuration file has not been downloaded, we didn't not find a valid HTTP URL or assets paths in the environment file", this._appEnvironmentConfig.TRACE_SUGGESTIONS_CONFIG);
        console.log("this usually only means that the suggestions tab is not enabled for this app");
      }
    } else if (this._configDownloadStatus() === 'done' && showSuggestionsOnMapAfterDownload) {

      //trigger downloadstatus update
      //and also trigger interface update if necessary by updating config update 

      this._configDownloadStatus.set('init');
      
      //override default value for 'route_centroids_on_map' if necessary
      if (this._configData().form_options.route_centroids_on_map.form_checked !== showSuggestionsOnMapAfterDownload) {
        const checkConfigData = TraceSuggestionsComponent.checkConfigData(this._configData());
        checkConfigData.form_options.route_centroids_on_map.form_checked = showSuggestionsOnMapAfterDownload;
        this._configData.set(checkConfigData);
      }

      this._configDownloadStatus.set('done');
    }
  }
}
